$(function () {
  $('#animation').on('click', function (e) {
    e.preventDefault();
    var box = $("#webmasterdata");
    box.slideToggle('slow');
  });
});